<template>
  <div class="img">
    <img :src="mb" alt="" class="w-100" :id="id" v-if="states.isMobile">
    <img :src="pc" alt="" class="w-100" :id="id" v-else>
  </div>
</template>

<script>
export default {
  name: "ResponsiveImg",
  inject: ['states'],
  props: ['mb', 'pc', 'id']
}
</script>

<style scoped>
  .img {
    width: 100%;
  }
</style>